/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./unsyncedChanges.vue?vue&type=template&id=156e437a"
import script from "./unsyncedChanges.vue?vue&type=script&lang=js"
export * from "./unsyncedChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports